import { z } from 'zod/v4'

// Load before any schemas: Safari document previews can restrict eval after startup.
z.config({ jitless: true })
